import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Main from './views/Main.vue'
import Planner from './views/Planner.vue'
import Board from './views/Board.vue'
import SignUp from './auth/SignUp'
import Login from './auth/Login'
import UserAccount from './views/UserAccount'
import UserPreferences from './views/UserPreferences'

import firebase from 'firebase/app';
import 'firebase/auth';


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },

    {
      path: '/app',
      component: Main,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '',
          redirect: { name: "planner" }
        },
        {
          path: 'planner',
          name: 'planner',
          component: Planner
        },
        {
          path: 'board/:boardId',
          name: 'board',
          component: Board,
          props: true
        },
        {
          path: 'user/account',
          name: 'userAccount',
          component: UserAccount
        },
        {
          path: 'user/preferences',
          name: 'userPreferences',
          component: UserPreferences
        },
      ]
    },

    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(
        /* webpackChunkName: "about" */
        './views/extra/About.vue'
      )
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import(
        /* webpackChunkName: "privacy" */ 
        './views/extra/Privacy.vue'
      )
    },  
    {
      path: '/terms',
      name: 'terms',
      component: () => import(
        /* webpackChunkName: "terms" */ 
        './views/extra/Terms.vue'
        )
    },
    {
      path: '/help',
      name: 'help',
      component: () => import(
        /* webpackChunkName: "help" */
        './views/extra/Help.vue'
        )
    },

  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(rec => rec.meta.requiresAuth)) {
    let user = firebase.auth().currentUser;
    if (user) {
      next();
    } else {
      next({name: "login"})
    }
  } else {
    next();
  }
});

export default router;
